import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { CutiBersamaPage } from "@/components/pages/CutiBersamaPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";

export const Route = createFileRoute("/en/joint-leave/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).filter((h) => h.type === "cuti-bersama").map((h) => ({
          name: h.name, date: h.date, description: `Indonesian joint leave ${y}.`,
          url: `/en/joint-leave/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Joint Leave (Cuti Bersama) Indonesia ${y} - Official SKB Dates` },
        { name: "description", content: `Complete list of joint leave (cuti bersama) dates in Indonesia ${y} based on the Joint Ministerial Decree (SKB 3 Menteri).` },
        { property: "og:title", content: `Joint Leave Indonesia ${y}` },
        { property: "og:description", content: `Official joint leave dates in Indonesia ${y}.` },
      ],
      links: [{ rel: "canonical", href: `https://hari.co.id/en/joint-leave/${y}/` }],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Home", url: "/en" },
          { name: `${y}`, url: `/en/${y}` },
          { name: `Joint Leave ${y}`, url: `/en/joint-leave/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "en") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: () => {
    const { y } = Route.useLoaderData();
    return <CutiBersamaPage y={y} locale="en" />;
  },
  notFoundComponent: () => (
    <SiteShell locale="en"><div className="py-16 text-center"><h1 className="text-2xl font-bold">Invalid year</h1></div></SiteShell>
  ),
});